export const connectTypeConnect = 'connect';
export const recipientCollege = 'COLLEGE';
export const responderUser = 'USER';
export const primarySourceApp = 'app';

export const secondarySourceRequestInfo = '/request-info';
export const updateCollegeDegreeUrl = '/college/update/collegeMajordata';

export const trackSourceType = {
  APP_PRIMARY: 'app',
  SECONDARY_SIMILAR_SCHOOL: 'similar-school-clicked',
};

export const collegeDetailConstants = {
  TUITION_ASSISTANCE_FUNDING_LIMIT: 250,
};

export const excludedRotcBranch = [20, 21];

export const giBillLink = {
  ACTIVE:
    'https://collegerecon.com/how-to-apply-post-9-11-gi-bill-active-duty-veterans/',
  DEPENDENT:
    'https://collegerecon.com/post-9-11-gi-bill-application-guide-spouses-dependents/',
};

export const MILITARY_STATUS = [
  { name: 'Active Duty', value: 'Active' },
  { name: 'National Guard', value: 'Guard' },
  { name: 'Reserve', value: 'Reserve' },
  { name: 'Retiree', value: 'Retired' },
  { name: 'Veteran', value: 'Veteran' },
  { name: 'Spouse', value: 'Spouse' },
  { name: 'Dependent', value: 'Dependent' },
  { name: 'Other', value: 'Other' },
];

export const OHA_CALCULATOR_RANK = [
  { name: 'E1', value: 'e1' },
  { name: 'E2', value: 'e2' },
  { name: 'E3', value: 'e3' },
  { name: 'E4', value: 'e4' },
  { name: 'E5', value: 'e5' },
  { name: 'E6', value: 'e6' },
  { name: 'E7', value: 'e7' },
  { name: 'E8', value: 'e8' },
  { name: 'E9', value: 'e9' },
  { name: 'W1', value: 'w1' },
  { name: 'W2', value: 'w2' },
  { name: 'W3', value: 'w3' },
  { name: 'W4', value: 'w4' },
  { name: 'W5', value: 'w5' },
  { name: 'O1E', value: 'o1e' },
  { name: 'O2E', value: 'o2e' },
  { name: 'O3E', value: 'o3e' },
  { name: 'O1', value: 'o1' },
  { name: 'O2', value: 'o2' },
  { name: 'O3', value: 'o3' },
  { name: 'O4', value: 'o4' },
  { name: 'O5', value: 'o5' },
  { name: 'O6', value: 'o6' },
];

export const MARITAL_STATUSES = [
  {
    label: 'Single',
    value: 'Single',
  },
  {
    label: 'Married',
    value: 'Married',
  },
  {
    label: 'Widowed',
    value: 'Widowed',
  },
  {
    label: 'Divorced',
    value: 'Divorced',
  },
  {
    label: 'Prefer Not To Say',
    value: 'Prefer Not To Say',
  },
];

export const GENDERS = [
  {
    label: 'Male',
    value: 'Male',
  },
  {
    label: 'Female',
    value: 'Female',
  },
  {
    label: 'Non-binary',
    value: 'Non Binary',
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'Prefer Not To Say',
    value: 'Prefer Not To Say',
  },
];

export const ETHNICITIES = [
  {
    label: 'American Indian or Alaskan Native',
    value: 'American Indian or Alaskan Native',
  },
  {
    label: 'Hispanic/Latino',
    value: 'Hispanic/Latino',
  },
  {
    label: 'Asian',
    value: 'Asian',
  },
  {
    label: 'Black or African American',
    value: 'Black or African American',
  },
  {
    label: 'Native Hawaiian or Other Pacific Islander',
    value: 'Native Hawaiian or Other Pacific Islander',
  },
  {
    label: 'Caucasian / White',
    value: 'White',
  },
];

export const VA_DISABILITY_RATINGS: any[] = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
  { label: '40', value: 40 },
  { label: '50', value: 50 },
  { label: '60', value: 60 },
  { label: '70', value: 70 },
  { label: '80', value: 80 },
  { label: '90', value: 90 },
  { label: '100', value: 100 },
];

export const NORMAL_COLLEGE: any[] = [
  { id: 0, name: 'overview' },
  { id: 1, name: 'military' },
  { id: 2, name: 'stats' },
  { id: 3, name: 'degrees' },
  { id: 4, name: 'review' },
  { id: 5, name: 'contact' },
];

export const DEGREE_SPECIFIC_COLLEGE: any[] = [
  { id: 0, name: 'overview' },
  { id: 1, name: 'degree_description' },
  { id: 2, name: 'stats' },
  { id: 3, name: 'contact' },
];

export const HOMEPAGE_LINK: any[] = [
  { name: 'yellow-ribbon', value: 'yellowribbon' },
  { name: 'online-schools', value: 'online' },
  { name: 'tuition-assistance', value: 'tuitionassistance' },
  { name: 'mba-programs', value: 'mbaprograms' },
  { name: 'trade-vocational', value: 'tradevocational' },
];

export const LEVELS = [
  {
    value: 5,
    label: "Bachelor's degree",
  },
  {
    value: 7,
    label: "Master's degree",
  },
  {
    value: 3,
    label: "Associate's degree",
  },
  {
    value: 17,
    label: 'Doctorate degree',
  },
  {
    value: 6,
    label: "Post- Bachelor's certificate",
  },
  {
    value: 8,
    label: "Post-Master's certificate",
  },
  {
    value: 18,
    label: 'Certificates',
  },
];

export const RANKS = [
  {
    value: 1,
    label: 'E-1',
  },
  {
    value: 2,
    label: 'E-2',
  },
  {
    value: 3,
    label: 'E-3',
  },
  {
    value: 4,
    label: 'E-4',
  },
  {
    value: 5,
    label: 'E-5',
  },
  {
    value: 6,
    label: 'E-6',
  },
  {
    value: 7,
    label: 'E-7',
  },
  {
    value: 8,
    label: 'E-8',
  },
  {
    value: 9,
    label: 'E-9',
  },
  {
    value: 10,
    label: 'O-1',
  },
  {
    value: 11,
    label: 'O-2',
  },
  {
    value: 12,
    label: 'O-3',
  },
  {
    value: 13,
    label: 'O-4',
  },
  {
    value: 14,
    label: 'O-5',
  },
  {
    value: 15,
    label: 'O-6',
  },
  {
    value: 16,
    label: 'O-7',
  },
  {
    value: 17,
    label: 'O-8',
  },
  {
    value: 18,
    label: 'O-9',
  },
  {
    value: 19,
    label: 'O-10',
  },
  {
    value: 20,
    label: 'W-1',
  },
  {
    value: 21,
    label: 'W-2',
  },
  {
    value: 22,
    label: 'W-3',
  },
  {
    value: 23,
    label: 'W-4',
  },
  {
    value: 24,
    label: 'W-5',
  },
];

export const MILITARY_BRANCHES = [
  {
    value: 1,
    label: 'Army',
  },
  {
    value: 4,
    label: 'Marine Corps',
  },
  {
    value: 2,
    label: 'Navy',
  },
  {
    value: 5,
    label: 'Air Force',
  },
  {
    value: 3,
    label: 'Coast Guard',
  },
  {
    value: 22,
    label: 'Space Force',
  },
  {
    value: 20,
    label: 'N/A',
  },
  {
    value: 21,
    label: 'Other',
  },
];

export const PRIMARY_BUCKETS = [
  {
    value: 4,
    label: 'Business, Marketing & Communications',
  },
  {
    value: 12,
    label: 'Healthcare & Health',
  },
  {
    value: 6,
    label: 'Computer Technology & IT',
  },
  {
    value: 11,
    label: 'Engineering',
  },
  {
    value: 8,
    label: 'Criminal Justice, Law & Protection',
  },
  {
    value: 18,
    label: 'Psychology',
  },
  {
    value: 19,
    label: 'Trade & Vocational',
  },
  {
    value: 13,
    label: 'Liberal Arts & Humanities',
  },
  {
    value: 10,
    label: 'Education & Teaching',
  },
  {
    value: 17,
    label: 'Physical Science',
  },
  {
    value: 3,
    label: 'Art, Design & Performing Arts',
  },
  {
    value: 1,
    label: 'Agriculture & Animal Science',
  },
];

export const SECONDARY_BUCKETS = [
  {
    value: 10,
    label: 'Accounting & Finance',
    bucketId: 4,
  },
  {
    value: 94,
    label: 'Advertising',
    bucketId: 4,
  },
  {
    value: 11,
    label: 'Business Administration',
    bucketId: 4,
  },
  {
    value: 213,
    label: 'Business Analytics',
    bucketId: 4,
  },
  {
    value: 197,
    label: 'Business Operations Support and Assistant Services',
    bucketId: 4,
  },
  {
    value: 17,
    label: 'Communications',
    bucketId: 4,
  },
  {
    value: 178,
    label: 'Data Analytics',
    bucketId: 4,
  },
  {
    value: 14,
    label: 'Economics',
    bucketId: 4,
  },
  {
    value: 154,
    label: 'Entrepreneurship/Entrepreneurial Studies',
    bucketId: 4,
  },
  {
    value: 60,
    label: 'Hospitality/ Tourism',
    bucketId: 4,
  },
  {
    value: 13,
    label: 'Human Resources',
    bucketId: 4,
  },
  {
    value: 121,
    label: 'International Business/Trade',
    bucketId: 4,
  },
  {
    value: 186,
    label: 'Leadership & Management',
    bucketId: 4,
  },
  {
    value: 189,
    label: 'Logistics & Supply Chain Management',
    bucketId: 4,
  },
  {
    value: 214,
    label: 'Management in Energy',
    bucketId: 4,
  },
  {
    value: 12,
    label: 'Marketing & Retail',
    bucketId: 4,
  },
  {
    value: 190,
    label: 'Procurement & Acquisition',
    bucketId: 4,
  },
  {
    value: 188,
    label: 'Project Management',
    bucketId: 4,
  },
  {
    value: 125,
    label: 'Public Administration',
    bucketId: 4,
  },
  {
    value: 110,
    label: 'Public Relations',
    bucketId: 4,
  },
  {
    value: 183,
    label: 'Public Sector Management',
    bucketId: 4,
  },
  {
    value: 187,
    label: 'Real Estate',
    bucketId: 4,
  },
  {
    value: 119,
    label: 'Sports and Fitness Administration',
    bucketId: 4,
  },
  {
    value: 93,
    label: 'Statistics & Business Analytics',
    bucketId: 4,
  },
  {
    value: 89,
    label: 'Biotechnology',
    bucketId: 12,
  },
  {
    value: 208,
    label: 'Chiropractic / Chiropractor',
    bucketId: 12,
  },
  {
    value: 48,
    label: 'Dentistry ',
    bucketId: 12,
  },
  {
    value: 47,
    label: 'Eastern Medicine',
    bucketId: 12,
  },
  {
    value: 146,
    label: 'Emergency Medical Technician (EMT Paramedic)',
    bucketId: 12,
  },
  {
    value: 176,
    label: 'Health Data Analysis',
    bucketId: 12,
  },
  {
    value: 50,
    label: 'Health Science',
    bucketId: 12,
  },
  {
    value: 46,
    label: 'Healthcare Administration',
    bucketId: 12,
  },
  {
    value: 174,
    label: 'Integrative and Functional Medicine',
    bucketId: 12,
  },
  {
    value: 49,
    label: 'Lab Sciences',
    bucketId: 12,
  },
  {
    value: 203,
    label: 'Medical Residency',
    bucketId: 12,
  },
  {
    value: 209,
    label: 'Naturopathic',
    bucketId: 12,
  },
  {
    value: 153,
    label: 'Neuroscience',
    bucketId: 12,
  },
  {
    value: 45,
    label: 'Nursing',
    bucketId: 12,
  },
  {
    value: 83,
    label: 'Nutrition',
    bucketId: 12,
  },
  {
    value: 181,
    label: 'Occupational Therapy / Sciences',
    bucketId: 12,
  },
  {
    value: 195,
    label: 'Optometry',
    bucketId: 12,
  },
  {
    value: 52,
    label: 'Pharmacy',
    bucketId: 12,
  },
  {
    value: 51,
    label: 'Physical Therapy/ Exercise Science',
    bucketId: 12,
  },
  {
    value: 99,
    label: 'Physican Assistant',
    bucketId: 12,
  },
  {
    value: 84,
    label: 'Pre-healthcare Studies',
    bucketId: 12,
  },
  {
    value: 175,
    label: 'Public Health',
    bucketId: 12,
  },
  {
    value: 173,
    label: 'Radiology and Medical Imaging Sciences',
    bucketId: 12,
  },
  {
    value: 207,
    label: 'Surgery Residency/Fellowship Programs',
    bucketId: 12,
  },
  {
    value: 217,
    label: 'Artificial Intelligence',
    bucketId: 6,
  },
  {
    value: 18,
    label: 'Computer Science',
    bucketId: 6,
  },
  {
    value: 156,
    label: 'Cyber Security & Operations',
    bucketId: 6,
  },
  {
    value: 20,
    label: 'Data Analytics & Data Science',
    bucketId: 6,
  },
  {
    value: 179,
    label: 'Data Science',
    bucketId: 6,
  },
  {
    value: 112,
    label: 'Information Sciences',
    bucketId: 6,
  },
  {
    value: 95,
    label: 'Information Technology',
    bucketId: 6,
  },
  {
    value: 21,
    label: 'IT Management',
    bucketId: 6,
  },
  {
    value: 80,
    label: 'IT Security',
    bucketId: 6,
  },
  {
    value: 19,
    label: 'IT Support',
    bucketId: 6,
  },
  {
    value: 96,
    label: 'Management Information Systems',
    bucketId: 6,
  },
  {
    value: 82,
    label: 'Aerospace, Aviation, Aeronautical, and Astronautical Engineering',
    bucketId: 11,
  },
  {
    value: 44,
    label: 'Bio/ Chemical Engineering',
    bucketId: 11,
  },
  {
    value: 92,
    label: 'Biomedical & Medical Engineering',
    bucketId: 11,
  },
  {
    value: 98,
    label: 'Civil Engineering',
    bucketId: 11,
  },
  {
    value: 39,
    label: 'Computer Engineering',
    bucketId: 11,
  },
  {
    value: 211,
    label: 'Conflict & Dispute Resolution',
    bucketId: 18,
  },
  {
    value: 40,
    label: 'Construction Engineering',
    bucketId: 11,
  },
  {
    value: 182,
    label: 'Counter Terrorism',
    bucketId: 8,
  },
  {
    value: 157,
    label: 'Criminal Justice Policy',
    bucketId: 8,
  },
  {
    value: 158,
    label: 'Criminal Justice, General',
    bucketId: 8,
  },
  {
    value: 41,
    label: 'Electrical Engineering',
    bucketId: 11,
  },
  {
    value: 199,
    label: 'Energy Systems Engineering',
    bucketId: 11,
  },
  {
    value: 43,
    label: 'Engineering General',
    bucketId: 11,
  },
  {
    value: 38,
    label: 'Engineering Technology',
    bucketId: 11,
  },
  {
    value: 159,
    label: 'Finance Crime',
    bucketId: 8,
  },
  {
    value: 27,
    label: 'Homeland Security',
    bucketId: 8,
  },
  {
    value: 72,
    label: 'Human Behavior Studies',
    bucketId: 18,
  },
  {
    value: 137,
    label: 'Human Services, General',
    bucketId: 18,
  },
  {
    value: 97,
    label: 'Industrial Engineering',
    bucketId: 11,
  },
  {
    value: 139,
    label: 'Legal Assistant/Paralegal',
    bucketId: 8,
  },
  {
    value: 25,
    label: 'Legal/ Law Studies',
    bucketId: 8,
  },
  {
    value: 42,
    label: 'Mechanical Engineering',
    bucketId: 11,
  },
  {
    value: 204,
    label: 'Nuclear Engineering',
    bucketId: 11,
  },
  {
    value: 26,
    label: 'Police/Corrections/ Criminal Studies',
    bucketId: 8,
  },
  {
    value: 71,
    label: 'Psychology Studies',
    bucketId: 18,
  },
  {
    value: 191,
    label: 'Airframe & Powerplant',
    bucketId: 19,
  },
  {
    value: 152,
    label: 'American/United States Studies/Civilization',
    bucketId: 13,
  },
  {
    value: 104,
    label: 'Anthropology',
    bucketId: 13,
  },
  {
    value: 212,
    label: 'Arabic Language & Literature Studies',
    bucketId: 13,
  },
  {
    value: 37,
    label: 'Architecture Studies',
    bucketId: 13,
  },
  {
    value: 131,
    label: 'Art Teacher',
    bucketId: 10,
  },
  {
    value: 78,
    label: 'Auto/ Transportation Studies',
    bucketId: 19,
  },
  {
    value: 144,
    label: 'Automotive Mechanics Technician',
    bucketId: 19,
  },
  {
    value: 79,
    label: 'Aviation',
    bucketId: 19,
  },
  {
    value: 151,
    label: 'Biology Teacher',
    bucketId: 10,
  },
  {
    value: 198,
    label: 'Carpentry / Carpenters',
    bucketId: 19,
  },
  {
    value: 168,
    label: 'Computer Technician',
    bucketId: 19,
  },
  {
    value: 77,
    label: 'Construction/ Labor',
    bucketId: 19,
  },
  {
    value: 23,
    label: 'Cosmetology, Grooming, Haircare & Styling',
    bucketId: 19,
  },
  {
    value: 216,
    label: 'Creative Writing',
    bucketId: 13,
  },
  {
    value: 28,
    label: 'Culinary Arts & Food Services',
    bucketId: 19,
  },
  {
    value: 31,
    label: 'Culinary Management',
    bucketId: 19,
  },
  {
    value: 57,
    label: 'Culinary Studies',
    bucketId: 19,
  },
  {
    value: 54,
    label: 'Cultural & Language Studies',
    bucketId: 13,
  },
  {
    value: 134,
    label: 'Curriculum and Instruction',
    bucketId: 10,
  },
  {
    value: 163,
    label: 'Dental Assistant',
    bucketId: 19,
  },
  {
    value: 114,
    label: 'Early Childhood Education',
    bucketId: 10,
  },
  {
    value: 33,
    label: 'Education Administration',
    bucketId: 10,
  },
  {
    value: 34,
    label: 'Education/ Teacher Development',
    bucketId: 10,
  },
  {
    value: 76,
    label: 'Electrician Technology',
    bucketId: 19,
  },
  {
    value: 170,
    label: 'Electrocardiograph Technology/Technician',
    bucketId: 19,
  },
  {
    value: 111,
    label: 'Elementary Education',
    bucketId: 10,
  },
  {
    value: 75,
    label: 'Emergency Services',
    bucketId: 19,
  },
  {
    value: 200,
    label: 'Energy Systems',
    bucketId: 19,
  },
  {
    value: 201,
    label: 'Engineering Technologies/Technicians',
    bucketId: 19,
  },
  {
    value: 102,
    label: 'English',
    bucketId: 13,
  },
  {
    value: 149,
    label: 'English as a Second Language/ESL Language Instructor',
    bucketId: 10,
  },
  {
    value: 126,
    label: 'English/Language Arts Education',
    bucketId: 10,
  },
  {
    value: 171,
    label: 'Executive Assistant - Certificate',
    bucketId: 19,
  },
  {
    value: 192,
    label: 'Fire Science & Fire Services',
    bucketId: 19,
  },
  {
    value: 210,
    label: 'Funeral Service & Mortuary Science',
    bucketId: 19,
  },
  {
    value: 36,
    label: 'General Disciplines Teacher Education',
    bucketId: 10,
  },
  {
    value: 61,
    label: 'General, Multi-/Interdisciplinary Studies',
    bucketId: 13,
  },
  {
    value: 202,
    label:
      'Heating, Air Conditioning, Ventilation and Refrigeration Maintenance Technology/Technician (HAC, HACR, HVAC, HVACR)',
    bucketId: 19,
  },
  {
    value: 169,
    label: 'Hemodialysis Technician',
    bucketId: 19,
  },
  {
    value: 106,
    label: 'History',
    bucketId: 13,
  },
  {
    value: 132,
    label: 'Humanities/Humanistic Studies',
    bucketId: 13,
  },
  {
    value: 194,
    label: 'HVACR',
    bucketId: 19,
  },
  {
    value: 101,
    label: 'International Relations / Global Studies',
    bucketId: 13,
  },
  {
    value: 107,
    label: 'Journalism',
    bucketId: 13,
  },
  {
    value: 142,
    label: 'Junior High/Intermediate/Middle School Education',
    bucketId: 10,
  },
  {
    value: 35,
    label: 'Language Teacher Education',
    bucketId: 10,
  },
  {
    value: 56,
    label: 'Library Science & Administration ',
    bucketId: 13,
  },
  {
    value: 172,
    label: 'Massage Therapy',
    bucketId: 19,
  },
  {
    value: 58,
    label: 'Mathematics',
    bucketId: 13,
  },
  {
    value: 164,
    label: 'Medical Administrative Assistant',
    bucketId: 19,
  },
  {
    value: 162,
    label: 'Medical Assistant',
    bucketId: 19,
  },
  {
    value: 160,
    label: 'Medical Coding and Billing',
    bucketId: 19,
  },
  {
    value: 161,
    label: 'Medical Transcription Editing',
    bucketId: 19,
  },
  {
    value: 118,
    label: 'Music Education',
    bucketId: 10,
  },
  {
    value: 167,
    label: 'Personal Trainer',
    bucketId: 19,
  },
  {
    value: 165,
    label: 'Pharmacy Technician',
    bucketId: 19,
  },
  {
    value: 108,
    label: 'Philosophy',
    bucketId: 13,
  },
  {
    value: 123,
    label: 'Physical Education Teaching / Coaching',
    bucketId: 10,
  },
  {
    value: 103,
    label: 'Political Science',
    bucketId: 13,
  },
  {
    value: 140,
    label: 'Reading Teacher',
    bucketId: 10,
  },
  {
    value: 55,
    label: 'Religious Studies',
    bucketId: 13,
  },
  {
    value: 196,
    label: 'ROTC',
    bucketId: 13,
  },
  {
    value: 128,
    label: 'School Counseling and Guidance',
    bucketId: 10,
  },
  {
    value: 81,
    label: 'Science Teacher',
    bucketId: 10,
  },
  {
    value: 122,
    label: 'Secondary Education',
    bucketId: 10,
  },
  {
    value: 53,
    label: 'Security & Military Science',
    bucketId: 13,
  },
  {
    value: 22,
    label: 'Skin/ Make-Up/ Nail Specialist',
    bucketId: 19,
  },
  {
    value: 59,
    label: 'Social Sciences',
    bucketId: 13,
  },
  {
    value: 145,
    label: 'Social Studies Teacher',
    bucketId: 10,
  },
  {
    value: 109,
    label: 'Social Work',
    bucketId: 13,
  },
  {
    value: 105,
    label: 'Sociology',
    bucketId: 13,
  },
  {
    value: 100,
    label: 'Spanish',
    bucketId: 13,
  },
  {
    value: 32,
    label: 'Special Education',
    bucketId: 10,
  },
  {
    value: 73,
    label: 'Trade/ Technicians',
    bucketId: 19,
  },
  {
    value: 74,
    label: 'Vehicle/ Engine Technology/ Repair',
    bucketId: 19,
  },
  {
    value: 166,
    label: 'Veterinary Assistant',
    bucketId: 19,
  },
  {
    value: 193,
    label: 'Welding',
    bucketId: 19,
  },
  {
    value: 129,
    label: 'Womens Studies',
    bucketId: 13,
  },
  {
    value: 1,
    label: 'Agriculture Business & Production',
    bucketId: 1,
  },
  {
    value: 2,
    label: 'Agriculture Science',
    bucketId: 1,
  },
  {
    value: 4,
    label: 'Animal & Livestock Sciences',
    bucketId: 1,
  },
  {
    value: 124,
    label: 'Art History, Criticism and Conservation',
    bucketId: 3,
  },
  {
    value: 8,
    label: 'Art, Animation, Design General',
    bucketId: 3,
  },
  {
    value: 205,
    label: 'Astronomy',
    bucketId: 17,
  },
  {
    value: 120,
    label: 'Biochemistry',
    bucketId: 17,
  },
  {
    value: 67,
    label: 'Biology',
    bucketId: 17,
  },
  {
    value: 88,
    label: 'Chemistry',
    bucketId: 17,
  },
  {
    value: 65,
    label: 'Dance',
    bucketId: 3,
  },
  {
    value: 68,
    label: 'Earth & Environmental Sciences',
    bucketId: 17,
  },
  {
    value: 9,
    label: 'Fashion',
    bucketId: 3,
  },
  {
    value: 7,
    label: 'Film & Photography',
    bucketId: 3,
  },
  {
    value: 66,
    label: 'Genetics',
    bucketId: 17,
  },
  {
    value: 127,
    label: 'Geography',
    bucketId: 17,
  },
  {
    value: 117,
    label: 'Geology/Earth Science',
    bucketId: 17,
  },
  {
    value: 90,
    label: 'Graphic Design',
    bucketId: 3,
  },
  {
    value: 91,
    label: 'Interior Design',
    bucketId: 3,
  },
  {
    value: 63,
    label: 'Music & Singing',
    bucketId: 3,
  },
  {
    value: 70,
    label: 'Physical Sciences (Other)',
    bucketId: 17,
  },
  {
    value: 69,
    label: 'Physics',
    bucketId: 17,
  },
  {
    value: 206,
    label: 'Physiology',
    bucketId: 17,
  },
  {
    value: 64,
    label: 'Theatre',
    bucketId: 3,
  },
  {
    value: 5,
    label: 'Veterinary Science & Animal Care',
    bucketId: 1,
  },
];
